export const REQUIRED_ASSIGNED_VIEW = "Blank View";

const normalizeAssignedViewNames = (views) => {
  const assignedViewValues = Array.isArray(views)
    ? views
    : typeof views === "string"
      ? views.split(",")
      : [];

  return assignedViewValues
    .map((view) =>
      typeof view === "string" ? view.trim() : view?.viewName,
    )
    .filter(Boolean);
};

export const getSelectableAssignedViews = (views) =>
  normalizeAssignedViewNames(views).filter(
    (viewName) => viewName !== REQUIRED_ASSIGNED_VIEW,
  );

export const buildAssignedViewsPayload = (views) => [
  REQUIRED_ASSIGNED_VIEW,
  ...new Set(getSelectableAssignedViews(views)),
];
